import { createElement, type ReactElement } from "react";

import { CodeEntryForm } from "./code-entry-form.js";
import { EmailRequestForm } from "./email-request-form.js";

export { EmailRequestForm } from "./email-request-form.js";
export { CodeEntryForm } from "./code-entry-form.js";

const DEV_TURNSTILE_TOKEN_HINT = "zzk-dev-turnstile";

export function renderAuthPublicScreen(
  screenId: string,
  turnstileSiteKey: string,
): ReactElement | null {
  if (screenId === "magic-link-auth.login") {
    return createElement(EmailRequestForm, {
      turnstileSiteKey,
      devTurnstileToken: isDevelopmentSiteKey(turnstileSiteKey)
        ? DEV_TURNSTILE_TOKEN_HINT
        : undefined,
    });
  }
  if (screenId === "magic-link-auth.login-code") {
    return createElement(CodeEntryForm, {});
  }
  return null;
}

function isDevelopmentSiteKey(siteKey: string): boolean {
  return siteKey.startsWith("1x00000000");
}
